import { HttpContext, HttpContextToken } from '@angular/common/http';

export interface HandleErrorLocallyOptions {
  handleErrorLocally?: boolean;
}

// HttpContextToken is Angular request metadata, not a manual HTTP client.
// eslint-disable-next-line no-restricted-syntax -- name matches the Http* ban meant for HttpClient/XHR
export const HANDLE_ERROR_LOCALLY = new HttpContextToken<boolean>(() => false);

export function handleErrorLocallyHttpOptions(handleErrorLocally?: boolean): { context?: HttpContext } {
  if (!handleErrorLocally) {
    return {};
  }

  // eslint-disable-next-line no-restricted-syntax -- HttpContext is request metadata, not a manual HTTP client
  return { context: new HttpContext().set(HANDLE_ERROR_LOCALLY, true) };
}
